import { apiRequest } from "api-client";
import apiEndpoints from "constants/endpoints";
import { GET_CURRENT_USER, GET_CURRENT_USER_FAILURE, GET_CURRENT_USER_SUCCESS } from "store/actionTypes/auth";

export const getCurrentUser = () => {
  return (dispatch) => {
    dispatch({
      type: GET_CURRENT_USER,
    });
    apiRequest.get(`/${apiEndpoints.users}/me`)
      .then((data) => {
        dispatch({
          type: GET_CURRENT_USER_SUCCESS,
          payload: {
            userInfo: data,
          }
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_CURRENT_USER_FAILURE,
          payload: {
            error: err
          }
        });
      });
  };
};